import React, { Component } from "react";
import PropTypes from "prop-types";
import "./ListItemFixed.scss";
import { Col, Row } from "reactstrap";
/**
 * Položka listu.
 */

class ListItemFixed extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  render() {
    const { children } = this.props;
    return (
      <Row className={`list-item-fixed`}>
        <Col>{children}</Col>
      </Row>
    );
  }
}

export default ListItemFixed;
